import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray, reduxForm } from 'redux-form';

import Button from '@style-guide/components/Button';

import FormFieldSection from '@components/FormFieldSection';

import LinksList from './components/LinksList';

const LinksInfoForm = ({
  handleSubmit,
  loading,
  pristine,
  invalid,
  hasSaveError = false,
}) => (
  <form
    id="LinksInfoForm"
    onSubmit={handleSubmit}
  >
    <FormFieldSection
      heading="Links"
    >
      <FieldArray
        name="Links"
        component={LinksList}
        rerenderOnEveryChange
      />
    </FormFieldSection>
    <Button
      type="submit"
      disabled={((pristine || loading) && !hasSaveError) || invalid}
    >
      Save
    </Button>
  </form>
);

LinksInfoForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  hasSaveError: PropTypes.bool,
};

LinksInfoForm.displayName = 'LinksInfoForm';

export default reduxForm({
  form: 'LinksInfoForm',
  enableReinitialize: true,
})(LinksInfoForm);
